import Vue from 'vue'
import budgetCategoryApi from '@/api/budgetCategory.api'

const state = {
  budgetCategories: {}
}


const getters = {
  budgetCategoryById: (state) => (id) => {
    return state.budgetCategories[id]
  },

  budgetCategories: (state, getters, rootState) => {
    const list = Object.values(state.budgetCategories) || []
    return list.filter(x => x.seasonId === rootState.season.currentId) || []
  },

  budgetCategoriesByType: (state, getters, rootState) => (income) => {
    const list = Object.values(state.budgetCategories) || []
    return list.filter(x => x.seasonId === rootState.season.currentId && x.income === income) || []
  }
}


const actions = {
  async loadBudgetCategories ({ commit, rootState }) {
    const response = await budgetCategoryApi.getBudgetCategories(rootState.tenant.current)
    commit('SET_BUDGET_CATEGORIES', response.data)
  },

  async loadRelations ({ commit, rootState }, id) {
    const response = await budgetCategoryApi.getRelations(rootState.tenant.current, id)
    return response.data
  },

  async createBudgetCategory ({ commit, rootState }, budgetCategory) {
    const response = await budgetCategoryApi.createBudgetCategory(rootState.tenant.current, budgetCategory)
    commit('CREATE_BUDGET_CATEGORY', response.data)
    return response.data
  },

  async loadAndUpdateBudgetCategory ({ commit, rootState }, entityData) {
    const response = await budgetCategoryApi.getBudgetCategory(rootState.tenant.current, entityData.entityId)
    commit('UPDATE_BUDGET_CATEGORY', response.data)
    return response.data
  },

  async updateBudgetCategory ({ commit, rootState }, budgetCategory) {
    const response = await budgetCategoryApi.updateBudgetCategory(rootState.tenant.current, budgetCategory.id, budgetCategory)
    commit('UPDATE_BUDGET_CATEGORY', response.data)
  },

  async deleteBudgetCategory ({ commit, rootState }, { id }) {
    await budgetCategoryApi.deleteBudgetCategory(rootState.tenant.current, id)
    commit('DELETE_BUDGET_CATEGORY', id)
  }
}


const mutations = {
  SET_BUDGET_CATEGORIES (state, budgetCategories) {
    state.budgetCategories = {}
    for (const budgetCategory of budgetCategories) {
      Vue.set(state.budgetCategories, budgetCategory.id, budgetCategory)
    }
  },

  CREATE_BUDGET_CATEGORY (state, budgetCategory) {
    Vue.set(state.budgetCategories, budgetCategory.id, budgetCategory)
  },

  UPDATE_BUDGET_CATEGORY (state, budgetCategory) {
    Vue.set(state.budgetCategories, budgetCategory.id, budgetCategory)
  },

  DELETE_BUDGET_CATEGORY (state, id) {
    Vue.delete(state.budgetCategories, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
